let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fISNm")).then(() => parcelRequire('3QcaP'));